import React from 'react'
import { useLocation } from '@gatsbyjs/reach-router'

interface Props {
  src: string
}

const ConvertLeadForm: React.FC<Props> = (props) => {
  const location = useLocation()
  const formURL = new URL(props.src)
  formURL.search = location.search.slice(1)
  const frameSrc = formURL.toString()

  return (
    <iframe
      src={frameSrc}
      className='convert-lead-form'
    />
  )
}

export default ConvertLeadForm
